import { Box, Chip, Link } from '@mui/material';
import { ResourceType } from 'types/graphql';

interface ResourceProps {
    type: ResourceType;
    url: string;
}
const ResourceView = ({ type, url }: ResourceProps) => {
    const ResourceTypeHeading = () => {
        return (
            <label className="mb-5 font-bold">
                {type === 'Document'
                    ? 'Document'
                    : type === 'Video'
                        ? 'Media File'
                        : 'External Link'}
            </label>
        );
    };

    const ResourceCallToAction = () => {
        const handleClick = () => {
            window.open(url, '_blank', 'noopener');
        };

        switch (type) {
            case 'Document':
            case 'Video':
                return (
                    <Box display="flex" alignItems="center" gap={1}>
                        <Chip
                            sx={{ color: 'white' }}
                            color="primary"
                            size="small"
                            label="View"
                            onClick={handleClick}
                        />
                    </Box>
                );

            default: // Link
                return (
                    <Box>
                        <Link href={url} target="_blank" rel="noopener" color="inherit">
                            {url?.split('?')?.[0]}
                        </Link>
                    </Box>
                );
        }
    };

    return (
        <>
            <ResourceTypeHeading />
            <ResourceCallToAction />
        </>
    );
};

export default ResourceView;
